export const changeLog = {
    changeLogTitle: "Change Log",
    dateTimes: {
        today: "Today",
        yesterday: "Yesterday",
        todayAt: "Today at {{ time }}",
        yesterdayAt: "Yesterday at {{ time }}",
        dayAt: "{{ day }} at {{ time }}",
        aWeekAgo: "A week ago",
        weekday0: "Sunday",
        weekday1: "Monday",
        weekday2: "Tuesday",
        weekday3: "Wednesday",
        weekday4: "Thursday",
        weekday5: "Friday",
        weekday6: "Saturday",
    },
    labels: {
        layerFallbackName: "Layer",
        multipleLayers: "Multiple Layers",
        viewDetails: "View details",
    },
    subTitles: {
        layerImported: "Layer Imported",
        layersImported: "Layers Imported",
        layerUnlinked: "Layer Unlinked",
        layersUnlinked: "Layers Unlinked",
        layerCopied: "Layer Copied",
        layersCopied: "Layers Copied",
        layerCreated: "Layer Created",
        layerDeleted: "Layer Deleted",
        layerEdited: "Layer Edited",
    },
    details: {
        layerImported: "Layer imported: {{ layerName }}",
        layerUnlinked: "Layer unlinked: {{ layerName }}",
        layerCreated: "Layer created: {{ layerName }}",
        mapObjectsCreated: "{{ count }} Map Objects Created",
        mapObjectsDeleted: "{{ count }} Map Objects Deleted",
    },
} as const;
